<template>
  <div>
    <LoginOrPayView v-if="info.code===401"></LoginOrPayView>
    <div class="sell-indention" v-else>
      <div class="title">
        <div class="title__circle" />
        <span class="title__label">直播销量趋势</span>
      </div>
      <div id="SellTrendChart" v-show="isVip"></div>
      <BlurImage v-show="!isVip" src="https://s6.bihukankan.com/img/1638330529pic@2x.png" class="blur-image" vip-text="升级会员，即可查看"/>
      <div class="title">
        <div class="title__circle" />
        <span class="title__label">直播销售构成</span>
      </div>
      <template v-if="isVip">
        <Chart :analysisData="pieData"/>
        <Table :analysisData="pieData" label="销售额"/>
      </template>
      <BlurImage v-show="!isVip" src="https://s6.bihukankan.com/img/1638340172pic_1@2x.png" class="blur-image2" vip-text="升级会员，即可查看"/>
      <!--  相似商品    -->
      <div class="title margin">
        <div class="title__circle" />
        <span class="title__label">相似商品</span>
      </div>
      <template v-if="isProVip">
        <!--    相似推荐    -->
        <SimilarGoodsList :data="similarGoodsListApi"/>
      </template>
      <BlurImage v-show="!isProVip" src="https://s6.bihukankan.com/img/1640828363similarGoods.png" class="blur-image3" vip-text="升级专业版会员，即可查看"/>
    </div>
  </div>
</template>

<script>
  import {returnMax, getInterval} from '../../plugins/helper.js'
  import Chart from '../../modules/goods/components/Chart'
  import Table from '../../modules/goods/components/Table'
  import SimilarGoodsList from '../../modules/goods/components/similarGoodsList'
  export default {
    components:{ Chart, Table, SimilarGoodsList },
    props: {
      params:{ type:Object, default: () => ({}) },
      title:{ type:Number, default:0 }
    },
    watch: {
      '$route':{
        deep:true,
        handler(){
          this.getData()
        }
      },
      params:{
        deep:true,
        handler(){
          this.getData()
          this.getSimilarGoods()
        }
      },
      title(){
        this.getData()
      },
      info(newValue, oldValue) {
        this.drawChart()
      },
    },
    data() {
      return {
        info:[], // 折线图
        pieDataApi:[], // 饼图
        similarGoodsListApi:[], // 相似商品列表
      }
    },
    mounted() {
      this.getData()
      this.getSimilarGoods()
    },
    methods: {
      async getData(){
        if(this.$props.title !== 0 || !this.isVip){ return }
        this.$showLoading();
        const res = await this.$api.get(`v2/commodity/${this.$route.params.id}/salesTrend`,{params:this.$props.params}).catch(_=> ({data:[]}))
        const resp = await this.$api.get(`v2/commodity/${this.$route.params.id}/anchorSales`,{ params:this.$props.params }).catch(_=> ({data:[]})) // 饼图
        this.info = res.data || []
        this.pieDataApi = resp.data || []
        this.$toast.clear();
      },
      async getSimilarGoods(){
        const res = await this.$api.get('/v2/similarCommodity',{params:{commodityId:this.$route.params.id}}).catch(_=>({data:[]}))
        this.similarGoodsListApi = res.data || []
      },
      drawChart() {
        if (this.info.length > 0) {
          const color = ['#2877ff', '#ff5000']
          const _this = this
          let max1 = Math.max(..._this.info.map(ele => Number(ele.salesVolume)))
          let max2 = Math.max(..._this.info.map(ele => Number(ele.sales)))
          let chartYMax = getInterval([returnMax(max1), returnMax(max2)])
          echarts.init(
            document.getElementById('SellTrendChart')
          ).setOption({
            color,
            tooltip: {
              trigger: 'axis',
            },
            legend: {
              data: ['直播销量', '销售额'],
              bottom: 20,
            },
            grid: {
              left: 60,
              top: 30,
              bottom: 80,
              right: 60,
            },
            xAxis: [{
              type: 'category',
              data: _this.info.map(ele => moment(String(ele.date)).format('MM-DD')),
              axisLabel: {
                textStyle: {
                  color: '#848F9C'
                }
              },
              axisLine: {
                lineStyle: {
                  color: '#848F9C'
                }
              },
              axisTick: {
                color: '#848F9C'
              },
            }],
            yAxis: [{
                type: 'value',
                name: '直播销量',
                nameTextStyle: {
                  color: "#A1AEBF"
                },
                axisLabel: {
                  formatter(val) {
                    return _this.$indentation(val)
                  },
                  textStyle: {
                    color: color[0]
                  }
                },
                max: chartYMax[0],
                axisLine: {
                  show: false,
                },
                axisTick: {
                  show: false
                },
              },
              {
                type: 'value',
                name: '销售额',
                nameTextStyle: {
                  color: "#A1AEBF"
                },
                axisLabel: {
                  formatter(val) {
                    return _this.$indentation(val)
                  },
                  textStyle: {
                    color: color[1]
                  }
                },
                max: chartYMax[1],
                axisLine: {
                  show: false,
                },
                axisTick: {
                  show: false
                },
              }
            ],
            series: [{
                smooth: true,
                name: '直播销量',
                type: 'line',
                data: _this.info.map(ele => Number(ele.salesVolume).toFixed(0)),
                symbol: 'path://M511.928873 69.657937c-244.140632 0-442.345355 198.204723-442.345355 442.346673 0 244.134047 198.204723 442.336135 442.345355 442.336135 244.136681 0 442.337452-198.203406 442.337453-442.336135 0-244.140632-198.200772-442.346673-442.337453-442.346673z', //设定为实心点
                symbolSize: 7,
                itemStyle: {
                  normal: {
                    color: '#2877ff',
                    lineStyle: {
                      width: 2 //设置线条粗细
                    }
                  }
                },
              },
              {
                smooth: true,
                name: '销售额',
                type: 'line',
                yAxisIndex: 1,
                barWidth: 30,
                data: _this.info.map(ele => Number(ele.sales).toFixed(0)),
                symbol: 'path://M511.928873 69.657937c-244.140632 0-442.345355 198.204723-442.345355 442.346673 0 244.134047 198.204723 442.336135 442.345355 442.336135 244.136681 0 442.337452-198.203406 442.337453-442.336135 0-244.140632-198.200772-442.346673-442.337453-442.346673z', //设定为实心点
                symbolSize: 7,
                itemStyle: {
                  normal: {
                    color: '#ff5000',
                    lineStyle: {
                      width: 2 //设置线条粗细
                    }
                  }
                },
              }
            ]
          })
        }
      },
    },
    computed:{
      isVip(){
        return this.$store.state.userLevel && this.$store.state.userLevel <= 96
      },
      isProVip: (_this = this) => (_this.$store.state.userLevel && _this.$store.state.userLevel <= 95),
      pieData(){
        let arr = this.pieDataApi.slice(0,5)
        arr = arr.map( ele => ({ name: ele?.anchor?.name || '未知', value: ele.sales } ))
        const newArr = this.pieDataApi.length > 5 ? this.pieDataApi.slice(5,this.pieDataApi.length - 1) : []
        const otherValue = newArr.reduce((total,current) => Number(total) + Number(current.sales),0)
        return otherValue ? [...arr,{name:'其他',value:otherValue}] : arr
      },

    }
  }
</script>

<style lang="less" scoped>
.margin{
  margin-top: 0.4rem;
  margin-bottom: 0.16rem;
}
.blur-image{
  width: 7.51rem;
  height: 5.08rem;
}
.title{
  padding-left: 0.24rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  &__circle{
    width: 0.16rem;
    height: 0.16rem;
    background: #2877ff;
    border-radius: 100%;
  }
  &__label{
    font-size: 0.28rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4A4A4A;
    line-height: 0.28rem;
    margin-left: 0.16rem;
  }
}
  .sell-indention {
    padding-top: 0.28rem;

    .sell-seven-days {
      width: 6.9rem;
      margin: 0 auto;

      .sell-and-salesVolume {
        width: 100%;
        height: 1.4rem;
        background: rgba(255, 153, 0, 0.05);
        border-radius: .08rem;
      }
    }

    .bottom-orientation {
      margin-top: 0.6rem;
    }

    .item-orientation {
      flex: 1;
      text-align: center;

      .item-orientation-number {
        font-size: .36rem;
        color: #4a4a4a;
        font-weight: bold;
      }

      .item-orientation-title {
        color: #A1AEBF;
        font-size: .2rem;
        margin-top: .2rem;
      }

      .sell {
        color: #FF5500;
      }
    }

  }

  #SellTrendChart {
    width: 100vw;
    height: 5rem;
    margin-top: 0.26rem;
  }
  .blur-image2{
    width: 7.51rem;
    height: 8.96rem;
  }
  .blur-image3{
    width: 7.51rem;
    height: 7rem;
  }

</style>
